import db from '@/plugins/dexie';
import { WsEnviaDados } from './websocket';
import { nomesTabelas } from './tabelas';

export default async function sincronizaLocal() {
  const aAtualizar = nomesTabelas.filter((item) => ['lancamentoatividade']
    .includes(item.tabela));

  const post = [];
  const put = [];

  for (const item of aAtualizar) {
    // eslint-disable-next-line no-await-in-loop
    const tabela = await db[item.tabela].toArray();

    for (const entidade of tabela) {
      if (entidade.laadataatualizacao > entidade.laadatanuvem) {
        put.push(entidade);
      } else if (!entidade.laadatanuvem) {
        post.push(entidade);
      }
    }
  }
  console.log();
  await WsEnviaDados({ tipo: 'postLancamentoAtividade', msg: post });
  await WsEnviaDados({ tipo: 'updateLancamentoAtividade', msg: put });
  // await WsEnviaDados({ tipo: 'postLancamentoVisitaTecnica', msg: post });
  // await WsEnviaDados({ tipo: 'updateLancamentoVisitaTecnica', msg: post });
}
